import { ProjectsAdapter } from '~/services/adapters/projects.adapter';
import {
    ICreateEventWithClientRequest,
    IFilteredEventsResponse
} from '~/types/server.types';
import { convertCustomFieldsForServer } from '~/components/CustomFields/custom-fields.utils';

export class ProjectService extends ProjectsAdapter {
    createProjectWithClient(data: ICreateEventWithClientRequest) {
        const { custom_contact_fields } = data;
        const updatedFields = convertCustomFieldsForServer(
            custom_contact_fields
        );

        const updatedData = { ...data, custom_contact_fields: updatedFields };
        return super.createProjectWithClient(updatedData);
    }

    fetchRecentProjects(params?: {
        page: number;
        perPage: number;
        showArchivedWorkspaces: boolean;
        showUntrackedWorkspaces: boolean;
        sortColumn: string;
        sortDirection: number;
        stageId?: string;
    }): Promise<IFilteredEventsResponse> {
        const DEFAULT_VALUES = {
            page: 1,
            perPage: 5,
            showArchivedWorkspaces: false,
            showUntrackedWorkspaces: false,
            sortColumn: 'last_activity_date',
            sortDirection: -1
        };

        const data = {
            ...DEFAULT_VALUES,
            ...params
        };

        return super._fetchRecentProjects(data).then(response => ({
            data: response.data,
            last_page: response.last_page,
            cur_page: response.cur_page || response.page
        }));
    }
}
